<template>
  <div
    id="category"
    v-if="isHomeCategory"
    class="bg-documentGray category-container"
    :class="isIdpService ? 'nav-category' : 'category-nav'"
    :style="`left: ${categoryBtnLocation}px`"
  >
    <div
      v-if="categoryList"
      class="category-wrapper"
      :class="[
        { 'category-nav-inner': !isIdpService },
        {
          'category-wrapper__scrollBar': categoryList.length > 10,
        },
      ]"
    >
      <CategoryListComponent
        type="SINGLE"
        :isIdpService="isIdpService"
        :categoryList="categoryList"
        :categoryTotalPage="categoryTotalPage"
        parentClassList="t-body1 t-color-bodyGrayA font-r cursor-pointer l-spacing48 category-item"
        childClassList="t-body1 t-color-bodyGrayA font-r cursor-pointer l-spacing48"
      />
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */
export default {
  components: {
    CategoryListComponent: () => import("./CategoryListComponent.vue"),
  },
  props: [
    "isHomeCategory",
    "isIdpService",
    "categoryList",
    "categoryBtnLocation",
    "categoryTotalPage",
  ],
};
</script>

<style scoped>
.category-container {
  position: fixed;
  width: 306px;
  height: auto;
  left: 200px;
  top: 68px;
  z-index: 1001;
  padding: 28px 0 29px;
  background: none !important;
}
.category-wrapper {
  position: fixed;
  top: 68px;
  width: max-content;
  min-width: 306px;
  max-height: 550px;
  background: var(--DocumentGray);
  z-index: 1001;
  padding: 8px 0 !important;
  border-radius: 4px;
  font-family: "Noto Sans", "Noto Sans KR", "KhmerOS_sys", sans-serif;
  overflow: scroll;
  flex-wrap: nowrap;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  overflow-x: hidden;
}
.category-wrapper::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
.category-wrapper__scrollBar {
  -ms-overflow-style: auto !important; /* IE and Edge */
  scrollbar-width: thin !important; /* Firefox */
}
.category-wrapper__scrollBar::-webkit-scrollbar {
  display: block !important; /* Chrome, Safari, Opera */
}
.category-wrapper {
  display: flex;
  flex-direction: column;
  padding: 0;
}
.category-item {
  box-sizing: border-box;
  width: 100%;
  min-height: 48px;
  height: auto;
  color: var(--BodygrayA);
  display: flex;
  padding: 16px;
  font-weight: 300;
}
.category-item:hover {
  background-color: var(--BlackHover);
  font-weight: bold;
}
.category-item:hover button {
  font-weight: bold;
  color: var(--HeadlineBlack) !important;
}
</style>
